import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail, Shield, Clock, LogIn } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_surfside-guard/artifacts/223cawun_1508.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0A] border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img
                src={LOGO_URL}
                alt="Surfside Patrol"
                className="h-16 w-16 object-contain"
              />
              <div className="ml-3">
                <span className="text-[#F5C518] font-bold text-xl font-['Barlow_Condensed']">SURFSIDE</span>
                <span className="text-white font-bold text-xl font-['Barlow_Condensed'] ml-1">PATROL</span>
              </div>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed mb-4">
              Professional security services for Southern California. Licensed, bonded, and insured.
            </p>
            <div className="flex items-center text-[#F5C518] font-bold">
              <Shield className="h-5 w-5 mr-2" />
              <span>PPO #15982</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 font-['Barlow_Condensed'] text-lg">
              Our Services
            </h4>
            <ul className="space-y-3">
              {[
                'Executive Protection',
                'K9 Security',
                'Drone Surveillance',
                'Armed Security',
                'Patrol Services',
                'CCTV Monitoring'
              ].map((service) => (
                <li key={service}>
                  <Link
                    to="/services"
                    className="text-zinc-500 hover:text-[#F5C518] transition-colors text-sm"
                  >
                    {service}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 font-['Barlow_Condensed'] text-lg">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:714-588-2460"
                  className="flex items-start text-zinc-500 hover:text-[#F5C518] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="h-5 w-5 mr-3 text-[#F5C518] flex-shrink-0 mt-0.5" />
                  <span>714-588-2460</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:surfside.josh4995@gmail.com"
                  className="flex items-start text-zinc-500 hover:text-[#F5C518] transition-colors"
                  data-testid="footer-email"
                >
                  <Mail className="h-5 w-5 mr-3 text-[#F5C518] flex-shrink-0 mt-0.5" />
                  <span>surfside.josh4995@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-start text-zinc-500" data-testid="footer-address">
                  <MapPin className="h-5 w-5 mr-3 text-[#F5C518] flex-shrink-0 mt-0.5" />
                  <span>2102 Business Center Dr<br />Irvine, CA 92612</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-bold uppercase tracking-wider mb-6 font-['Barlow_Condensed'] text-lg">
              Available 24/7
            </h4>
            <div className="flex items-center text-zinc-500 mb-4">
              <Clock className="h-5 w-5 mr-3 text-[#F5C518]" />
              <span>24 Hour Dispatch</span>
            </div>
            <p className="text-zinc-500 text-sm mb-6">
              Our dispatch center is always ready to respond to your security needs.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-[#F5C518] text-black font-bold uppercase tracking-wider px-6 py-3 hover:bg-[#E5B508] transition-colors"
              data-testid="footer-get-quote"
            >
              Request Quote
            </Link>
            <a
              href="https://security-roster-7.emergent.host/login"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-zinc-500 hover:text-[#F5C518] transition-colors text-sm"
              data-testid="footer-staff-login"
            >
              <LogIn className="h-4 w-4" />
              Staff Login
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-zinc-600 text-sm">
              © {currentYear} Surfside Patrol Private Security. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-4 md:mt-0">
              <Link to="/services" className="text-zinc-600 hover:text-[#F5C518] text-sm">
                Services
              </Link>
              <Link to="/about" className="text-zinc-600 hover:text-[#F5C518] text-sm">
                About
              </Link>
              <Link to="/contact" className="text-zinc-600 hover:text-[#F5C518] text-sm">
                Contact
              </Link>
              <Link to="/privacy" className="text-zinc-600 hover:text-[#F5C518] text-sm" data-testid="footer-privacy">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-zinc-600 hover:text-[#F5C518] text-sm" data-testid="footer-terms">
                Terms of Service
              </Link>
              <Link to="/sms-consent" className="text-zinc-600 hover:text-[#F5C518] text-sm" data-testid="footer-sms-consent">
                SMS Consent
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
